import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { Wrapper, H, P, Image, Divider } from '@farewill/ui'
import { smallCaps } from '@farewill/ui/helpers/text'
import { screenMin } from '@farewill/ui/helpers/responsive'

const StyledP = styled(P)``

const StyledWrapper = styled(Wrapper)`
  display: block;

  ${screenMin.m`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `}

  &,
  &:hover {
    text-decoration: none;

    ${StyledP} {
      text-decoration: underline;
    }
  }
`

const StyledImageWrapper = styled(Wrapper)`
  flex: 0 0 120px;
`

const StyledNextHeader = styled(H)`
  ${smallCaps}
`

const NextArticleLink = ({ title, link, image }) => (
  <>
    <Divider />
    <StyledWrapper margin={['M', 0]} tag={Link} to={link}>
      <div>
        <StyledNextHeader
          size="M"
          tag="h3"
          margin={[0, 0, 'XS']}
          aria-label="Next article in guide"
        >
          Next
        </StyledNextHeader>
        <StyledP>{title}</StyledP>
      </div>

      {image && (
        <StyledImageWrapper margin={['S', 0, 0]} marginFromM={[0, 0, 0, 'S']}>
          <Image
            path={image.file.url}
            formatPath={({ path, width }) => `${path}?w=${width}`}
            width={120}
            height={120}
            stretch
          />
        </StyledImageWrapper>
      )}
    </StyledWrapper>

    <Divider />
  </>
)

NextArticleLink.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  image: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }).isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
}

export default NextArticleLink
